export function toFit (cb,
  {
    dismissCondition = () => false,
    triggerCondition = () => true
  }) {
  if (!cb) {
    throw Error('Invalid required arguments');
  }

  // let previousTimeStamp = 0;
  let tick = false;

  return function (event) {
    // const tempTimeStamp = previousTimeStamp;
    // previousTimeStamp = event.timeStamp;

    // if (!tick && (previousTimeStamp - tempTimeStamp) > 500) {
    if (!tick) {
      tick = true;
      return window.requestAnimationFrame(() => {
        if (dismissCondition()) {
          tick = false;
          return;
        }

        if (triggerCondition()) {
          tick = false;

          return cb();
        }
      });
    }

    // previousTimeStamp = event.timeStamp;
  };
}
